export const THREAD_NG_MAX_PATTERNS = 20;
export const THREAD_NG_MAX_PATTERN_LENGTH = 500;

export type ThreadNgValidation =
  | { patterns: string[]; error: null }
  | { patterns: null; error: string };

/** Each line is a RegExp source. No slash delimiters or implicit flags. */
export function validateThreadNgWords(input: string): ThreadNgValidation {
  if (input === "") return { patterns: [], error: null };
  const patterns = input.replace(/\r\n?/g, "\n").split("\n");
  if (patterns.length > THREAD_NG_MAX_PATTERNS) {
    return { patterns: null, error: "NGワードは20件以内にしてください。" };
  }
  for (const [index, pattern] of patterns.entries()) {
    if (pattern.trim() === "") {
      return {
        patterns: null,
        error: `${index + 1}行目は空の式にできません。`,
      };
    }
    if (pattern.length > THREAD_NG_MAX_PATTERN_LENGTH) {
      return {
        patterns: null,
        error: `${index + 1}行目は500文字以内にしてください。`,
      };
    }
    try {
      new RegExp(pattern);
    } catch {
      return {
        patterns: null,
        error: `${index + 1}行目の正規表現が正しくありません。`,
      };
    }
  }
  return { patterns, error: null };
}
